import { Box } from '@mui/material';
import React, { ReactNode } from 'react';
import { OverviewHeaderContainer, OverviewImage } from './OverviewHeader.styles';
import Image from 'designSystem/DataDisplay/Image/Image';
import { ImageVariant } from 'types/media.types';
import Icon, { TIconName } from 'designSystem/Primitives/Icon/Icon';

interface OverviewHeaderProps {
  image?: ImageVariant | null;
  placeholderIconName?: TIconName;
  /**
   * @deprecated use placeholderIconName instead
   */
  placeholderImageUrl?: string;
  children: ReactNode;
}

const OverviewHeader: React.FC<OverviewHeaderProps> = ({
  placeholderImageUrl,
  placeholderIconName,
  image,
  children,
}) => {
  return (
    <OverviewHeaderContainer>
      <Box display="flex">
        {image && <Image image={image} width={130} height={130} />}

        {!image && (placeholderImageUrl || placeholderIconName) && (
          <>
            {/* TODO: Deprecated remove as soon as its not used anymore */}
            {placeholderImageUrl && !placeholderIconName && (
              <OverviewImage backgroundImage={placeholderImageUrl} />
            )}
            {placeholderIconName && <Icon name={placeholderIconName} color="blue-5" size="huge" />}
          </>
        )}

        <Box ml={2} flex={1}>
          {children}
        </Box>
      </Box>
    </OverviewHeaderContainer>
  );
};

export default OverviewHeader;
